module.exports = __webpack_public_path__ + "media/bip.6289c47f.wav";